import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './lib/posthog';
import App from './App';

// ── Boot-time hygiene (runs BEFORE React mounts) ────────────────
// Register the PWA service worker. The SW uses network-only for all
// Supabase / API calls so auth state is always fresh from the network.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch(() => { /* SW registration failed silently — app still works */ });
  });
}

// 2. Purge malformed / expired Supabase auth keys from localStorage.
//    Supabase persists sessions under keys like `sb-<project-ref>-auth-token`.
//    A corrupt or expired entry can wedge `getSession()` indefinitely.
try {
  const now = Math.floor(Date.now() / 1000);
  const keys = Object.keys(localStorage);
  for (const k of keys) {
    if (!k.startsWith('sb-')) continue;
    const raw = localStorage.getItem(k);
    if (!raw) continue;
    try {
      const parsed = JSON.parse(raw);
      // Token shape varies across supabase-js versions; expires_at can be at
      // top level or nested under currentSession.
      const expiresAt =
        parsed?.expires_at ??
        parsed?.currentSession?.expires_at ??
        parsed?.expiresAt ??
        null;
      if (expiresAt && Number(expiresAt) < now) {
        localStorage.removeItem(k);
      }
    } catch {
      // Malformed JSON → drop it.
      localStorage.removeItem(k);
    }
  }
} catch { /* localStorage unavailable (private mode, etc.) — ignore */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
